import FavouritePlayer from './FavouritePlayer';

export default FavouritePlayer;
